import { AxiosInstance } from 'axios';
import { Platform } from 'react-native';
import { AuthService } from 'app/auth/services/AuthService';
import { Telemetry } from 'app/services/telemetry/Telemetry';

export const setupRequestInterceptors = (http: AxiosInstance) => {
  http.interceptors.request.use(async (config) => {
    try {
      const token = await AuthService.getToken();

      if (token) {
        config.headers = config.headers || {};
        config.headers.Authorization = `Bearer ${token}`;
      }
    } catch (error) {
      Telemetry.log('warning', 'Failed to get token in request interceptor', { error: error as Error });
    }

    // On web, cache-busting request headers (Cache-Control/Pragma/Expires) are non-simple headers
    if (Platform.OS === 'web' && config.headers) {
      delete config.headers['Cache-Control'];
      delete config.headers['Pragma'];
      delete config.headers['Expires'];
    }

    return config;
  });
};
